import { useEffect } from 'react';
import ReactDOM from 'react-dom';

export function loadDOMComponent({ selector, callback }) {
	function load() {
		// console.log('loaded', selector);

		document.querySelectorAll(selector).forEach(container => {
			if (
				!container.getAttribute('react-loaded') &&
				!container.hasAttribute('skipload')
			) {
				container.setAttribute('react-loaded', true);

				var context = undefined;
				var props = undefined;

				try {
					props = JSON.parse(container.querySelector('[props]').textContent);
				} catch (e) {}

				try {
					context = JSON.parse(
						container.querySelector('[context]').textContent,
					);
				} catch (e) {}

				// var children = container.children;
				// for (var i = 0; i < children.length; i++) {
				//     var child = children[i];
				//
				//     console.log({child});
				//     if (['SCRIPT'].indexOf(child.tagName) === -1) {
				//
				//     }
				// }

				callback({
					container,
					context,
					props,
				});
			}
		});
	}

	function reload() {
		document.querySelectorAll(selector).forEach(container => {
			container.removeAttribute('react-loaded');
			ReactDOM.unmountComponentAtNode(container);
		});

		load();
	}

	document.addEventListener('DOMContentLoaded', load);
	document.addEventListener('nette-snippets', load);
	document.addEventListener('DOMContentLoadedForce', reload);
}

export function useEffectAsync(op, deps: any = []) {
	useEffect(() => {
		try {
			// @ts-ignore
			new Promise(resolve => {
				op().then(result => {
					resolve(result);
				});
			}).then();
		} catch (e) {
			console.log({e});
		}
	}, deps ?? []);
}
